import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Check,
  Printer,
  RotateCcw,
  Zap,
} from "feather-icons-react/build/IconComponents";
import "../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermColumns,
  TermStatusBar,
} from "../transactions/terminal/TerminalChrome";
import { useSelector } from "react-redux";
import {
  getbillwisepayment,
  getsupBill,
  savebillpayment,
} from "../../services/AccountApiServices";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { BillPaymentEntry } from "../../core/json/BillPaymentEntry";
import { FinancialYear } from "../../core/json/FinancialYear";
import { BillPaymentDetail } from "../../core/json/BillPaymentDetail";
import { Currency } from "../../core/json/Currency";
import { fetchBranchSettings } from "../../redux/settingbyBranch";
import { SupplierClass } from "../../core/json/SupplierClass";
import { getPrintSettingsByBranch } from "../../services/AdminApiServices";

const Billpaymentmodal = ({
  mode,
  data,
  handleClose,
  handleRefresh,
  bankorcash,
}) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invdate: dayjs().format("YYYY-MM-DD"),
      isCheque: false,
      amount: 0,
    },
  });
  const isCheque = watch("isCheque");
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [supBill, setsupBill] = useState([]);
  const [supplier, setSupplier] = useState(null);
  const [amount, setamount] = useState(0);
  const [printSettings, setPrintSettings] = useState([]); 
  
  // const [totals, setTotals] = useState({});
const [printAfterSubmit, setPrintAfterSubmit] = useState(false); // New state variable
  const { formatedsupplierList } = useSelector((state) => state.usersetting);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);
  const { branchsettings } = useSelector((state) => state.settings);
  useEffect(() => {
    dispatch(fetchBranchSettings(branch.guid));
  }, [branch]);

  useEffect(() => {
    const fetchPrintSettings = async () => {
      try {
        const response = await getPrintSettingsByBranch(branch?.guid);
        setPrintSettings(response);
      } catch (error) {
        console.error("Failed to fetch print settings", error);
      }
    };
  
    if (branch?.guid) {
      fetchPrintSettings();
    }
  }, [branch]);

  async function handleFill() {
    if (!supplier || amount <= 0) {
      return;
    }
    await handlebill(supplier);

    // const fillamount = amount;

    let remainingAmount = amount;

    if (amount <= totalbalance) {
      fields.forEach((field, index) => {
        const balance = parseFloat(watch(`items[${index}].balance`, 0)) || 0;

        if (remainingAmount > 0) {
          const payingAmount = Math.min(remainingAmount, balance);
          setValue(
            `items[${index}].paying`,
            payingAmount.toFixed(decimalpoints) || 0
          );
          setValue(
            `items[${index}].balance`,
            (balance - payingAmount).toFixed(decimalpoints) || 0
          );
          remainingAmount -= payingAmount;
        }
        if (remainingAmount <= 0) {
          // setValue("amount", 0);
          setamount(0);
        }
      });
    }
  }

  // Get branch from redux
  // Fetch sales quotations data
  const handleEntryNo = async () => {
    try {
      const response = await getbillwisepayment(branch);
      const receiptData = response.data;
      // Find the maximum number from the existing entries
      const maxEntryNumber =
        receiptData?.length > 0
          ? receiptData
              ?.map((data) => parseInt(data.no))
              ?.reduce((max, num) => Math.max(max, num), 0) // Find the maximum number
          : 0;

      let counter = maxEntryNumber + 1;
      setValue(`no`, counter);
      counter++;
    } catch (error) {
      console.error("Failed to fetch purchase invoices", error);
    }
  };

  // function resetmodal() {
  //   if (mode === "edit" && data) {
  //     setValue("no", data.no);
  //     setValue("paymentdate", data.date);
  //     setValue("supplier", data.supplier.guid);
  //     setValue("ledger", data.ledgerID);
  //     setValue("isCheque", data.isCheque);
  //     setamount(data.amount);
  //     // setValue("amount", data.amount);
  //     setValue("remark", data.narration);
  //     const groupedData = data?.billPaymentDetail.reduce((acc, e) => {
  //       const key = e.entryNumber;
  //       if (!acc[key]) {
  //         acc[key] = { ...e, amount: e.amount, discount: e.discount }; // Initialize the group
  //       } else {
  //         acc[key].amount += e.amount; // Sum amounts for the same entryNumber
  //         acc[key].discount += e.discount; // Sum discounts for the same entryNumber
  //       }
  //       return acc;
  //     }, {});
  //     const detail = Object.values(groupedData).map((e) => {
  //       const bal = (e.netTotal - (e.amount + e.discount)).toFixed(2); // Rounds balance to 2 decimal places

  //       // Return the transformed object
  //       return {
  //         masterID: e.masterID,
  //         purchaseMasterID: e.purchaseMasterID,
  //         purchaseReturnMasterID: e.purchaseReturnMasterID,
  //         billtype: e.transType,
  //         billno: e.entryNumber,
  //         // billno: e.purchaseMasterID,
  //         date: dayjs(e.entryDate).format("DD-MM-YYYY"),
  //         billamount: e.netTotal,
  //         paid: e.amount,
  //         paying: e.amount,
  //         discount: e.discount,
  //         invNo: e.invoiceNO,
  //         invdate: dayjs(e.entryDate).format("DD-MM-YYYY"), // Correct usage of dayjs
  //         balance: bal > 0 ? bal : 0,
  //       };
  //     });

  //     setValue("items", detail);
  //   }
  // }

  async function resetmodal() {
  if (mode === "edit" && data) {
    setValue("no", data.no);
    setValue("paymentdate", data.date);
    setValue("supplier", data.supplier.guid);
    setValue("ledger", data.ledgerID);
    setValue("isCheque", data.isCheque);
    setamount(data.amount);
    setValue("remark", data.narration);

    // 1. what other live payments have settled on each bill - the server
    //    leaves this payment's own lines out (excludeGuid)
    const response = await getsupBill(data.supplier.guid, branch, data.guid);
    const settledBefore = {};
    if (Array.isArray(response.data)) {
      response.data.forEach((bill) => {
        settledBefore[String(bill.purchaseMasterID).toLowerCase()] =
          (bill.amount || 0) + (bill.discount || 0);
      });
    }

    // 2. this payment's lines: paid = settled by the other payments,
    //    paying / discount = this payment's own amounts
    const detail = data?.billPaymentDetail.map((e) => {
      const key = String(e.purchaseMasterID).toLowerCase();
      // a bill missing from the open list is settled in full by the others
      const paidBefore = key in settledBefore ? settledBefore[key] : e.netTotal;
      const bal = e.netTotal - paidBefore - e.amount - e.discount;

      return {
        masterID: e.masterID,
        purchaseMasterID: e.purchaseMasterID,
        purchaseReturnMasterID: e.purchaseReturnMasterID,
        billtype: e.transType,
        billno: e.entryNumber,
        date: dayjs(e.entryDate).format("DD-MM-YYYY"),
        billamount: e.netTotal,
        paid: paidBefore,
        paying: e.amount,
        discount: e.discount,
        invNo: e.invoiceNO,
        invdate: dayjs(e.entryDate).format("DD-MM-YYYY"),
        balance: (bal > 0 ? bal : 0).toFixed(2),
      };
    });

    setValue("items", detail);
  }
}

  useEffect(() => {
    resetmodal();
  }, [data, append, remove]);

  useEffect(() => {
    const fetchData = async () => {
      if (mode === "add") {
        handleEntryNo();
        if (!isRowAdded && fields?.length === 0) {
          setIsRowAdded(true);
        }
      }
    };

    fetchData();
  }, []);

  const handlesaveorupdate = async (formData) => {
    const objbillpayment = new BillPaymentEntry();
    const objfinance = new FinancialYear();
    const objcurrency = new Currency();
    const objsupplier = new SupplierClass();
    objfinance.guid = branchsettings?.defaultFinancialYearGuID;
    objfinance.id = branchsettings?.defaultFinancialYearID;
    objcurrency.guid = branchsettings?.primaryCurrencyGUID;
    objbillpayment.guid = mode == "edit" ? data.guid : "";
    objbillpayment.id = mode == "edit" ? data.id : 0;
    objbillpayment.Currency = objcurrency;
    // one key per field (G-15): the class already carries Date and guid.
    // The date picker is bound to "paymentdate".
    objbillpayment.Date = dayjs(
      formData.paymentdate || formData.invdate
    ).format("YYYY-MM-DD");
    objbillpayment.No = formData.no;
    objsupplier.guid = formData.supplier;
    objbillpayment.Supplier = objsupplier;
    objbillpayment.Narration = formData.remark;
    objbillpayment.Amount = parseFloat(amount);
    objbillpayment.LedgerID = formData.ledger;
    objbillpayment.Branch = branch;
    objbillpayment.FinancialYear = objfinance;
    objbillpayment.Company = companyInfolist[0];
    objbillpayment.createdUser = userId.id;
    objbillpayment.updatedUser = userId.id;

    for (const {
      select,
      masterID,
      purchaseMasterID,
      purchaseReturnMasterID,
      paying,
      discount,
    } of formData.items) {
      if (select || paying > 0) {
        const objdetail = new BillPaymentDetail();
        objdetail.MasterID = masterID;
        objdetail.PurchaseMasterID = purchaseMasterID;
        objdetail.PurchaseReturnMasterID = purchaseReturnMasterID;
        objdetail.Amount = parseFloat(paying) || 0;
        objdetail.Discount = parseFloat(discount) || 0;
        objbillpayment.billPaymentDetail.push(objdetail);
      }
    }

    try {
      const response = await savebillpayment(objbillpayment);
      if (response.data !== true) {
        toast.error(response?.data?.Message || "Bill payment was not saved");
      } else {
        // fields.forEach((_, index) => remove(index))
        toast.success("success");
        handleClose();
        handleRefresh();
                               if (printAfterSubmit) {
           printA4Function();      // 👈 only called if user clicked "Save & Print"
           setPrintAfterSubmit(false); // reset flag
         }
        }
      } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error("Error handling :", error?.response?.data?.Message);
    }
  };
const printA4Function = () => {
  const formValues = watch();
  const fields = formValues?.items || [];

  // const company = companyInfolist?.[0] || {};
  // const companyName = company.name || "Company Name";
  // const companyAddress1 = company.address1 || "";
  // const companyAddress2 = company.address2 || "";
  // const companyAddress3 = company.address3 || "";
  // const companyPhone = company.phone || "-";
  // const companyEmail = company.email || "-";
  // const companyTIN = company.tin || "-";

  const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";

  const entryNumber = formValues.no || "-";
  const paymentDate = formValues.paymentdate
    ? dayjs(formValues.paymentdate).format("DD/MM/YYYY")
    : dayjs().format("DD/MM/YYYY");
  const supplierName =
    formatedsupplierList?.find((s) => s.value === formValues.supplier)?.label || "-";
  const ledgerObj = bankorcash?.find((l) => l.value === formValues.ledger);
  const ledgerName = ledgerObj?.label || "-";
  const paymentMode = ledgerObj?.mode || "Cash";
  const remark = formValues.remark || "-";

  // Totals
  const totalBillAmount = fields.reduce((acc, row) => acc + parseFloat(row.billamount || 0), 0);
  const totalPaid = fields.reduce((acc, row) => acc + parseFloat(row.paid || 0), 0);
  const totalPaying = fields.reduce((acc, row) => acc + parseFloat(row.paying || 0), 0);
  const totalDiscount = fields.reduce((acc, row) => acc + parseFloat(row.discount || 0), 0);
  const totalBalance = fields.reduce((acc, row) => acc + parseFloat(row.balance || 0), 0);

  const tableRows = fields
    .filter((row) => parseFloat(row.paying) > 0 || parseFloat(row.discount) > 0)
    .map((row, index) => {
      return `
        <tr>
          <td>${index + 1}</td>
          <td>${row.billno || "-"}</td>
          <td>${row.invNo || "-"}</td>
          <td>${row.date || "-"}</td>
          <td style="text-align:right;">${parseFloat(row.billamount || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.paid || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.paying || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.discount || 0).toFixed(2)}</td>
          <td style="text-align:right;">${parseFloat(row.balance || 0).toFixed(2)}</td>
        </tr>
      `;
    });

  const chequeDetails =
    paymentMode.toLowerCase() === "cheque"
      ? `
        <tr>
          <td><strong>Cheque No:</strong></td>
          <td>${formValues.chequeNo || "-"}</td>
        </tr>
        <tr>
          <td><strong>Cheque Date:</strong></td>
          <td>${formValues.chequedate ? dayjs(formValues.chequedate).format("DD/MM/YYYY") : "-"}</td>
        </tr>
        <tr>
          <td><strong>Bank Name:</strong></td>
          <td>${formValues.bankName || "-"}</td>
        </tr>
        <tr>
          <td><strong>Branch:</strong></td>
          <td>${formValues.branchName || "-"}</td>
        </tr>
      `
      : "";

  const printableContent = `
  <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          font-size: 12px;
          margin: 20px;
        }
        h2, h3 {
          margin: 0;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;
        }
        th, td {
          border: 1px solid #000;
          padding: 6px;
        }
        .header {
          text-align: center;
        }
        .info-table td {
          border: none;
          padding: 4px;
          text-align: left;
        }
        .totals-table {
          width: 35%;
          border-collapse: collapse;
          margin-top: 15px;
          float: right;
        }
        .totals-table td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 12px;
          text-align: right;
        }
        .totals-table td.label {
          text-align: left;
          width: 70%;
        }
      </style>
    </head>
    <body>
      <div class="header">
   <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
      </div>

      <h3 style="text-align:center; margin-top:10px;">BILL WISE PAYMENT</h3>

      <table class="info-table">
        <tr>
          <td><strong>Voucher No:</strong> ${entryNumber}</td>
          <td><strong>Date:</strong> ${paymentDate}</td>
        </tr>
        <tr>
          <td><strong>Supplier:</strong> ${supplierName}</td>
          <td><strong>Paid Through:</strong> ${ledgerName}</td>
        </tr>
        ${chequeDetails}
        <tr>
          <td colspan="2"><strong>Remarks:</strong> ${remark}</td>
        </tr>
      </table>

      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Bill No</th>
            <th>Invoice No</th>
            <th>Date</th>
            <th>Bill Amount</th>
            <th>Paid</th>
            <th>Paying</th>
            <th>Discount</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows.join("")}
        </tbody>
      </table>

      <table class="totals-table">
        <tr>
          <td class="label">Total Bill Amount:</td>
          <td>${totalBillAmount.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label">Total Paid:</td>
          <td>${totalPaid.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label">Total Paying:</td>
          <td>${totalPaying.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label">Total Discount:</td>
          <td>${totalDiscount.toFixed(2)}</td>
        </tr>
        <tr>
          <td class="label"><strong>Total Balance:</strong></td>
          <td><strong>${totalBalance.toFixed(2)}</strong></td>
        </tr>
      </table>
    </body>
  </html>
  `;

  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0px";
  iframe.style.height = "0px";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(printableContent);
  doc.close();

  iframe.contentWindow.focus();
  setTimeout(() => {
    iframe.contentWindow.print();
    iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
  }, 500);
};

  const handlebill = async (val) => {
    // setValue("amount", "");
    setamount(0);

    try {
      const response = await getsupBill(val, branch);

      if (Array.isArray(response.data)) {
        // one row per open bill (a purchase invoice and a return can share a
        // number, so nothing is grouped by number). paid = settled so far,
        // earlier discounts included; discount = this payment's discount.
        const data = response.data.map((e) => {
          const paidBefore = (e.amount || 0) + (e.discount || 0);
          // the server's balance (AC-18); the same sum on older APIs
          const bal = (e.balance ?? e.netTotal - paidBefore).toFixed(2);

          return {
            masterID: e.masterID,
            purchaseMasterID: e.purchaseMasterID,
            purchaseReturnMasterID: e.purchaseReturnMasterID,
            billtype: e.transType,
            billno: e.entryNumber,
            date: dayjs(e.entryDate).format("DD-MM-YYYY"),
            billamount: e.netTotal,
            paid: paidBefore,
            discount: 0,
            invNo: e.invoiceNO,
            invdate: dayjs(e.entryDate).format("DD-MM-YYYY"), // Correct usage of dayjs
            balance: bal,
          };
        });

        setValue("items", data);
        setsupBill(data);
      } else {
        setsupBill([]);
      }
    } catch (error) {
      console.error("Error fetching bill data:", error);
      setsupBill([]);
    }
  };
  const totalamount = fields?.reduce(
    (sum, _, index) =>
      sum + parseFloat(watch(`items[${index}].billamount`) || 0),
    0
  );
  const totalpaid = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].paid`) || 0),
    0
  );
  const totalpaying = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].paying`) || 0),
    0
  );
  const totaldiscount = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].discount`) || 0),
    0
  );
  const totalbalance = fields?.reduce(
    (sum, _, index) => sum + parseFloat(watch(`items[${index}].balance`) || 0),
    0
  );

  function handleAddPaying(index) {
    const billamount = getValues(`items[${index}].billamount`) || 0;
    const paid = getValues(`items[${index}].paid`) || 0;
    const paying = getValues(`items[${index}].paying`) || 0;
    const discount = getValues(`items[${index}].discount`) || 0;
    setValue("amount", totalpaying);
    setamount(totalpaying);
    const balance = billamount - paid;
    const finalBalance = balance - paying - discount;

    if (paying && paying > 0) {
      setValue(`items[${index}].select`, true);
    } else {
      setValue(`items[${index}].select`, false);
    }
    if (finalBalance >= 0) {
      setValue(`items[${index}].balance`, finalBalance);
    }
  }

  const checkfield =fields.length > 0 ? false : true

  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen
  const chrome = useTerminalChrome("billPayment");
  const docDate = watch("paymentdate");
  const supplierValue = watch("supplier");
  const ledgerValue = watch("ledger");
  const supplierName = formatedsupplierList?.find(
    (s) => s.value === supplierValue
  )?.label;
  const ledgerName = bankorcash?.find((b) => b.value === ledgerValue)?.label;
  // the date picker shows today until one is picked
  const dateShown = dayjs(docDate || undefined).format("DD-MM-YYYY");
  const fmt = (v) => (parseFloat(v) || 0).toFixed(2);

  return (
    <div
      className="modal fade show si-term si-term--txn"
      data-si-theme={chrome.theme}
      style={{ display: "block" }}
      tabIndex="-1"
    >
      <div className="modal-dialog si-dialog">
        <div className="modal-content si-content">
          <form className="si-form" onSubmit={handleSubmit(handlesaveorupdate)}>
            <div className="si-grid">
              <div className="si-left">
                {/* ============ COMMAND BAR ============ */}
                <TermCmdBar
                  chrome={chrome}
                  title="Bill Wise Payment"
                  docNo={watch("no")}
                  state={
                    mode === "edit"
                      ? { key: "edit", label: "Editing" }
                      : { key: "new", label: "New" }
                  }
                  onBack={handleClose}
                />
                {/* entry no. is generated - the header shows it */}
                <input
                  type="text"
                  className="si-offscreen"
                  tabIndex={-1}
                  aria-hidden="true"
                  {...register("no")}
                  required
                  disabled
                />

                {/* ============ HEADER FIELDS ============ */}
                <section className="si-strip">
                  <div className="si-strip-row si-strip-row--auto">
                    <div className="si-fld">
                      <label>Date</label>
                      <Controller
                        control={control}
                        name="paymentdate"
                        render={({ field: { onChange, value } }) => (
                          <DatePicker
                            className="si-date"
                            value={value ? dayjs(value) : dayjs()}
                            format="DD-MM-YYYY"
                            onChange={(date) =>
                              onChange(date ? date.format("YYYY-MM-DD") : null)
                            } // Update on change
                          />
                        )}
                      />
                    </div>

                    <div className="si-fld">
                      <label>
                        Supplier <span className="si-req">*</span>
                      </label>
                      <Controller
                        control={control}
                        name={`supplier`}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            classNamePrefix="react-select"
                            options={formatedsupplierList}
                            placeholder="Supplier"
                            value={formatedsupplierList?.find(
                              (customer) => customer?.value === value
                            )}
                            onChange={(selectedOption) => {
                              onChange(selectedOption.value);
                              setSupplier(selectedOption.value);
                              handlebill(selectedOption.value);
                            }}
                            menuPortalTarget={menuHost}
                            menuPosition="fixed"
                            styles={siSelectStyles}
                          />
                        )}
                      />
                    </div>

                    <div className="si-fld">
                      <label>
                        Ledger <span className="si-req">*</span>
                      </label>
                      <Controller
                        control={control}
                        name="ledger"
                        rules={{
                          required: "Selecting a ledger is required", // Validation rule for required
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error }, // Access error object to show validation message
                        }) => (
                          <>
                            <Select
                              classNamePrefix="react-select"
                              options={bankorcash}
                              placeholder="Cash/Bank"
                              value={bankorcash?.find(
                                (bank) => bank?.value === value
                              )}
                              onChange={(selectedOption) =>
                                onChange(selectedOption?.value)
                              }
                              menuPortalTarget={menuHost}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                            />
                            {error && (
                              <span className="si-err">{error.message}</span>
                            )}
                          </>
                        )}
                      />
                    </div>

                    <div className="si-fld">
                      <label>Cheque</label>
                      <div>
                        <label className="si-remember" style={{ margin: 0 }}>
                          <input type="checkbox" {...register("isCheque")} />
                          <span>Cheque ?</span>
                        </label>
                      </div>
                    </div>

                    {isCheque && (
                      <>
                        {["chequeNo", "accNo", "holdername"].map(
                          (field, index) => (
                            <div key={index} className="si-fld">
                              <label>{`${
                                field.charAt(0).toUpperCase() +
                                field.slice(1).replace(/([A-Z])/g, " $1")
                              }`}</label>
                              <input
                                type="text"
                                className="si-in"
                                {...register(field)}
                                required
                              />
                            </div>
                          )
                        )}

                        <div className="si-fld">
                          <label>Cheque Date</label>
                          <Controller
                            control={control}
                            name="chequedate"
                            render={({ field: { onChange, value } }) => (
                              <DatePicker
                                className="si-date"
                                value={value ? dayjs(value) : dayjs()}
                                format="DD-MM-YYYY"
                                onChange={(date) =>
                                  onChange(
                                    date ? date.format("YYYY-MM-DD") : null
                                  )
                                }
                              />
                            )}
                          />
                        </div>
                      </>
                    )}

                    <div className="si-fld">
                      <label>Amount</label>
                      <div className="si-fld-ctl">
                        <input
                          type="number"
                          min={0}
                          step="any"
                          value={amount}
                          onChange={(e) => setamount(e.target.value)}
                          className="si-in si-in--mono"
                          // {...register("amount", {
                          //   required: "Amount is required",
                          //   validate: {
                          //     withinBalance: (value) =>
                          //       (!isNaN(value) && value <= totalbalance) ||
                          //       "Amount can't be greater than balance",
                          //   },
                          // })}
                        />
                        <button
                          className="si-iconbtn"
                          style={{ height: "24px" }}
                          onClick={handleFill}
                          type="button"
                          title="Spread the amount over the open bills"
                        >
                          <Zap />
                          <span>Fill</span>
                        </button>
                      </div>
                      {amount > totalbalance && (
                        <span className="si-err">
                          Amount cant be greater than balance
                        </span>
                      )}
                    </div>

                    <div className="si-fld si-fld--wide">
                      <label>Remarks</label>
                      <input
                        type="text"
                        className="si-in"
                        placeholder="Note for this payment"
                        {...register("remark")}
                      />
                    </div>
                  </div>
                </section>

                {/* ============ BILLS ============ */}
                <section className="si-lines">
                  <TermColumns chrome={chrome} columns={[]}>
                    <button
                      type="button"
                      className="si-iconbtn"
                      onClick={resetmodal}
                    >
                      <RotateCcw />
                      <span>Cancel</span>
                    </button>
                  </TermColumns>

                  <div className="si-tablewrap">
                    <table className="si-table" style={{ minWidth: "1060px" }}>
                      <thead>
                        <tr>
                          <th style={{ width: "40px" }} aria-label="Select" />
                          <th style={{ width: "80px" }}>Bill Type</th>
                          <th style={{ width: "90px" }}>Bill No.</th>
                          <th style={{ width: "100px" }}>Date</th>
                          <th className="n" style={{ width: "110px" }}>
                            Bill Amount
                          </th>
                          <th className="n" style={{ width: "100px" }}>
                            Paid
                          </th>
                          <th className="n" style={{ width: "110px" }}>
                            Paying
                          </th>
                          <th className="n" style={{ width: "100px" }}>
                            Discount
                          </th>
                          <th className="n" style={{ width: "100px" }}>
                            Balance
                          </th>
                          <th style={{ width: "100px" }}>Inv. No.</th>
                          <th style={{ width: "100px" }}>Inv. Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields?.map((obj, index) => {
                          return (
                            <tr className="si-line" key={index}>
                              <td
                                data-label="Select"
                                style={{ textAlign: "center" }}
                              >
                                <input
                                  type="checkbox"
                                  style={{ accentColor: "var(--accent)" }}
                                  {...register(`items[${index}].select`)}
                                />
                              </td>
                              <td data-label="Bill Type">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text si-cellin--ro"
                                  {...register(`items[${index}].billtype`)}
                                  disabled
                                />
                              </td>
                              <td data-label="Bill No.">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text si-cellin--ro"
                                  {...register(`items[${index}].billno`)}
                                  disabled
                                />
                              </td>
                              <td data-label="Date">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text si-cellin--ro"
                                  {...register(`items[${index}].date`)}
                                  disabled
                                />
                              </td>
                              <td className="n" data-label="Bill Amount">
                                <input
                                  type="number"
                                  min={0}
                                  step="any"
                                  className="si-cellin si-cellin--ro"
                                  {...register(`items[${index}].billamount`)}
                                  disabled
                                />
                              </td>
                              <td className="n" data-label="Paid">
                                <input
                                  type="number"
                                  min={0}
                                  step="any"
                                  className="si-cellin si-cellin--ro"
                                  {...register(`items[${index}].paid`)}
                                  disabled
                                />
                              </td>
                              <td className="n" data-label="Paying">
                                <input
                                  type="number"
                                  min={0}
                                  step="any"
                                  className="si-cellin"
                                  // onChange={(e) =>
                                  //   handleAddPaying(index, e.target.value)
                                  // }
                                  {...register(`items[${index}].paying`, {
                                    validate: {
                                      withinBalance: (value) => {
                                        const balance =
                                          getValues(
                                            `items[${index}].billamount`
                                          ) || 0;
                                        const paid =
                                          getValues(`items[${index}].paid`) ||
                                          0;
                                        const discount =
                                          getValues(
                                            `items[${index}].discount`
                                          ) || 0;
                                        const amount =
                                          balance - paid - discount;
                                        return (
                                          (!isNaN(value) && value <= amount) ||
                                          `Amount can't be greater than balance `
                                        );
                                      },
                                    },
                                    onBlur: (e) => {
                                      handleAddPaying(
                                        index
                                        // e.target.value
                                      ); // Call your custom function
                                    },
                                  })}
                                  // onChange={(e) =>
                                  //   handlebalance(e.target.value, "pay")
                                  // }
                                />

                                {errors?.items?.[index]?.paying && (
                                  <span className="si-err">
                                    {errors.items[index].paying.message}
                                  </span>
                                )}
                              </td>
                              <td className="n" data-label="Discount">
                                <input
                                  type="number"
                                  min={0}
                                  step="any"
                                  className="si-cellin"
                                  {...register(`items[${index}].discount`, {
                                    validate: {
                                      withinBalance: (value) => {
                                        const balance =
                                          getValues(
                                            `items[${index}].billamount`
                                          ) || 0;
                                        const paid =
                                          getValues(`items[${index}].paid`) ||
                                          0;
                                        const paying =
                                          getValues(`items[${index}].paying`) ||
                                          0;
                                        const amount = balance - paid - paying;
                                        return (
                                          (!isNaN(value) && value <= amount) ||
                                          `Amount can't be greater than balance ${amount}`
                                        );
                                      },
                                    },
                                    onBlur: (e) => {
                                      handleAddPaying(
                                        index
                                        // e.target.value
                                      );
                                    },
                                  })}
                                />
                                {errors?.items?.[index]?.discount && (
                                  <span className="si-err">
                                    {errors.items[index].discount.message}
                                  </span>
                                )}
                              </td>
                              <td className="n" data-label="Balance">
                                <input
                                  type="number"
                                  min={0}
                                  step="any"
                                  className="si-cellin si-cellin--ro"
                                  {...register(`items[${index}].balance`)}
                                  disabled
                                />
                              </td>
                              <td data-label="Inv. No.">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text si-cellin--ro"
                                  {...register(`items[${index}].invNo`)}
                                  disabled
                                />
                              </td>
                              <td data-label="Inv. Date">
                                <input
                                  type="text"
                                  className="si-cellin si-cellin--text si-cellin--ro"
                                  {...register(`items[${index}].invdate`)}
                                  disabled
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {fields?.length === 0 && (
                      <div className="si-empty">
                        <p className="big">No bills yet</p>
                        <p>Pick a supplier to load their open bills.</p>
                      </div>
                    )}
                  </div>

                  <div className="si-lines-foot">
                    <span>
                      Bills <b>{fields.length}</b>
                    </span>
                    <span>
                      Bill amount <b>{fmt(totalamount)}</b>
                    </span>
                    <span>
                      Paid <b>{fmt(totalpaid)}</b>
                    </span>
                    <span>
                      Paying <b>{fmt(totalpaying)}</b>
                    </span>
                    <span>
                      Discount <b>{fmt(totaldiscount)}</b>
                    </span>
                    <span>
                      Balance <b>{fmt(totalbalance)}</b>
                    </span>
                  </div>
                </section>

                {/* ============ STATUS BAR ============ */}
                <TermStatusBar context={[supplierName, ledgerName, dateShown]} />
              </div>

              {/* ============ RAIL ============ */}
              <aside className="si-rail">
                <div className="si-rail-scroll">
                  <div className="si-card">
                    <div className="si-card-h">
                      <span>Paid to</span>
                      <span className="r">{dateShown}</span>
                    </div>
                    <div className="si-party">
                      <div className="nm">
                        {supplierName || "No supplier selected"}
                      </div>
                      <div className="meta">
                        {supplierName
                          ? `Payment ${watch("no") || "—"}${
                              ledgerName ? ` · from ${ledgerName}` : ""
                            }`
                          : "Pick the supplier to load open bills"}
                      </div>
                    </div>
                  </div>

                  <div className="si-card">
                    <div className="si-card-h">Summary</div>
                    <div className="si-tot">
                      <div className="si-tr">
                        <span className="l">Bills</span>
                        <span className="v">{fields.length}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Bill amount</span>
                        <span className="v">{fmt(totalamount)}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Already paid</span>
                        <span className="v">{fmt(totalpaid)}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Discount</span>
                        <span className="v">{fmt(totaldiscount)}</span>
                      </div>
                      <div className="si-tr">
                        <span className="l">Balance after</span>
                        <span className="v">{fmt(totalbalance)}</span>
                      </div>
                    </div>
                    <div className="si-net">
                      <span className="l">Paying now</span>
                      <span className="v" title={fmt(totalpaying)}>
                        {fmt(totalpaying)}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="si-actions">
                  <button
                    type="submit"
                    className="si-btn si-btn--primary"
                    onClick={() => setPrintAfterSubmit(true)} // 👈 set flag before submit
                  >
                    <Printer />
                    <span>Save &amp; print</span>
                  </button>
                  <button
                    className="si-btn si-btn--ghost"
                    type="submit"
                    disabled={checkfield || totalpaying==0  }
                    style={
                      checkfield || totalpaying == 0
                        ? { opacity: 0.5, cursor: "not-allowed" }
                        : undefined
                    }
                  >
                    <Check />
                    <span>Save only</span>
                  </button>
                </div>
              </aside>
            </div>
          </form>
        </div>
      </div>
      {/* react-select menus portal here so they inherit the .si-term tokens */}
      <div ref={setMenuHost} className="si-menu-host" />
    </div>
  );
};
export default Billpaymentmodal;
